export default __webpack_public_path__ + "static/media/Eight.cfca3d5c.png";